/*** IMPORTS FROM imports-loader ***/
(function() {

define(['pip-model', 'pip-events', 'window'], function (pip, pipEvents, window) {

    function initEventListeners() {
        var PRIMARY_CATEGORY = 'interaction';
        var EVENT_NAME = 'pip sub-content';
        var SECTION = 'super-sku';

        var callback = function (event, data) {
            var thdAnalyticsEvent = {
                category: {
                    primaryCategory: PRIMARY_CATEGORY
                },
                eventInfo: {
                    eventName: EVENT_NAME
                },
                subContent: {
                    section: SECTION,
                    component: data.component,
                    target: data.target,
                }
            };

            if (window.digitalData && window.digitalData.event) {
                window.digitalData.event.push(thdAnalyticsEvent);
            }
        }

        pipEvents.ssku.modalOpen.off('.modalOpen');
        pipEvents.ssku.modalOpen.on('.modalOpen', callback);

        pipEvents.ssku.calculateEstimate.off('.calculateEstimate');
        pipEvents.ssku.calculateEstimate.on('.calculateEstimate', callback);
    }

    return {
        init: function init() {
            initEventListeners();
        }
    }
});

}.call(window));